<template>
  <a-modal
    title="通道配置"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    :confirmLoading="loading"
    width="700px"
  >
    <a-form-model
      ref="form"
      :model="formData"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
    >
      <!-- 基本信息 -->
      <a-row :gutter="16">
        <a-col :span="24">
          <a-alert
            message="通道配置信息"
            :description="`当前配置通道：${channelData.channelName} (${channelData.channelId})`"
            type="info"
            show-icon
            style="margin-bottom: 24px;"
          />
        </a-col>
      </a-row>

      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="商户费率" prop="feeRate">
            <a-input-number
              v-model="formData.feeRate"
              :min="0"
              :max="100"
              :step="0.01"
              :precision="2"
              style="width: 100%"
              placeholder="请输入费率"
            />
            <span slot="suffix">%</span>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="费用计算方式" prop="feeType">
            <a-select v-model="formData.feeType" placeholder="请选择">
              <a-select-option :value="1">百分比</a-select-option>
              <a-select-option :value="2">固定金额</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="单笔最小" prop="minAmount">
            <a-input-number
              v-model="formData.minAmount"
              :min="0"
              :step="0.01"
              :precision="2"
              style="width: 100%"
              placeholder="最小金额"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="单笔最大" prop="maxAmount">
            <a-input-number
              v-model="formData.maxAmount"
              :min="0"
              :step="0.01"
              :precision="2"
              style="width: 100%"
              placeholder="最大金额"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="日累计限额" prop="dayMaxAmount">
            <a-input-number
              v-model="formData.dayMaxAmount"
              :min="0"
              :step="0.01"
              :precision="2"
              style="width: 100%"
              placeholder="日限额"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="月累计限额" prop="monthMaxAmount">
            <a-input-number
              v-model="formData.monthMaxAmount"
              :min="0"
              :step="0.01"
              :precision="2"
              style="width: 100%"
              placeholder="月限额"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="排序权重" prop="sortOrder">
            <a-input-number
              v-model="formData.sortOrder"
              :min="0"
              :max="999"
              style="width: 100%"
              placeholder="数值越大越优先"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="状态" prop="state">
            <a-radio-group v-model="formData.state">
              <a-radio :value="1">启用</a-radio>
              <a-radio :value="0">禁用</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-model-item label="备注" prop="remark">
            <a-textarea
              v-model="formData.remark"
              :rows="3"
              placeholder="请输入备注信息"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <!-- 配置参数 -->
      <a-divider>扩展配置参数</a-divider>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-model-item label="配置参数" prop="configParams">
            <a-textarea
              v-model="configParamsText"
              :rows="8"
              placeholder="请输入JSON格式的配置参数，如：&#10;{&#10;  &quot;apiKey&quot;: &quot;your_api_key&quot;,&#10;  &quot;secretKey&quot;: &quot;your_secret_key&quot;&#10;}"
            />
            <div class="config-tips">
              <a-icon type="info-circle" />
              <span>请输入有效的JSON格式配置参数</span>
            </div>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: 'ChannelConfigModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    channelData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      formData: {
        feeRate: 0,
        feeType: 1,
        minAmount: 0,
        maxAmount: 0,
        dayMaxAmount: 0,
        monthMaxAmount: 0,
        sortOrder: 0,
        state: 1,
        remark: ''
      },
      configParamsText: '',
      rules: {
        feeRate: [
          { required: true, message: '请输入商户费率', trigger: 'blur' },
          { type: 'number', min: 0, max: 100, message: '费率必须在0-100之间', trigger: 'blur' }
        ],
        feeType: [
          { required: true, message: '请选择费用计算方式', trigger: 'change' }
        ],
        minAmount: [
          { required: true, message: '请输入单笔最小金额', trigger: 'blur' },
          { type: 'number', min: 0, message: '最小金额不能小于0', trigger: 'blur' }
        ],
        maxAmount: [
          { required: true, message: '请输入单笔最大金额', trigger: 'blur' },
          { type: 'number', min: 0, message: '最大金额不能小于0', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.initFormData()
      }
    }
  },
  methods: {
    // 初始化表单数据
    initFormData () {
      if (this.channelData && Object.keys(this.channelData).length > 0) {
        this.formData = {
          feeRate: this.channelData.feeRate || 0,
          feeType: this.channelData.feeType || 1,
          minAmount: this.channelData.minAmount || 0,
          maxAmount: this.channelData.maxAmount || 0,
          dayMaxAmount: this.channelData.dayMaxAmount || 0,
          monthMaxAmount: this.channelData.monthMaxAmount || 0,
          sortOrder: this.channelData.sortOrder || 0,
          state: this.channelData.state !== undefined ? this.channelData.state : 1,
          remark: this.channelData.remark || ''
        }

        // 处理配置参数
        if (this.channelData.configParams) {
          try {
            this.configParamsText = JSON.stringify(this.channelData.configParams, null, 2)
          } catch (error) {
            this.configParamsText = ''
          }
        } else {
          this.configParamsText = ''
        }
      }
    },

    // 确认提交
    async handleOk () {
      try {
        // 表单验证
        await this.$refs.form.validate()

        // 验证配置参数JSON格式
        let configParams = null
        if (this.configParamsText.trim()) {
          try {
            configParams = JSON.parse(this.configParamsText)
          } catch (error) {
            this.$message.error('配置参数JSON格式不正确')
            return
          }
        }

        // 验证金额逻辑
        if (this.formData.minAmount >= this.formData.maxAmount) {
          this.$message.error('单笔最小金额不能大于等于最大金额')
          return
        }

        this.loading = true

        // 准备提交数据
        const submitData = {
          ...this.formData,
          channelId: this.channelData.channelId,
          configParams: configParams
        }

        // 提交数据
        this.$emit('submit', submitData)
      } catch (error) {
        console.error('配置验证失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 取消操作
    handleCancel () {
      this.$emit('cancel')
      this.resetForm()
    },

    // 重置表单
    resetForm () {
      this.formData = {
        feeRate: 0,
        feeType: 1,
        minAmount: 0,
        maxAmount: 0,
        dayMaxAmount: 0,
        monthMaxAmount: 0,
        sortOrder: 0,
        state: 1,
        remark: ''
      }
      this.configParamsText = ''

      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.config-tips {
  margin-top: 8px;
  color: #666;
  font-size: 12px;

  .anticon {
    margin-right: 4px;
    color: #1890ff;
  }
}

.ant-form-model-item {
  margin-bottom: 16px;
}
</style>
